import { createAction, props } from '@ngrx/store'
import { AssignedTo, LeavePolicy } from './leave-policy.state'
import { User } from '../auth/auth.state'

// Action to initiate loading of LeavePolicy by ID
export const loadLeavePolicyById = createAction(
  '[LeavePolicy] Load LeavePolicy By ID',
  props<{ id: string }>()
)

// Action when business data is loaded successfully
export const loadLeavePolicyByIdSuccess = createAction(
  '[LeavePolicy] Load LeavePolicy By ID Success',
  props<{ leavepolicy: LeavePolicy }>()
)

// Action when there is an error loading the LeavePolicy data
export const loadLeavePolicyByIdFailure = createAction(
  '[LeavePolicy] Load LeavePolicy By ID Failure',
  props<{ error: string }>()
)

//Load Assigned To
export const loadAssignedTo = createAction(
  '[Leave Policy] Load Assigned To',
  props<{ leavePolicyId: string; params: string | null; page?: number; limit?: number }>()
)
export const loadAssignedToSuccess = createAction(
  '[Leave Policy] Load Assigned To Success',
  props<{ assignedTo: AssignedTo[]; totalCount: number }>()
)
export const loadAssignedToFailure = createAction(
  '[Leave Policy] Load Assigned To Failure',
  props<{ error: string }>()
)

//Load UnAssigned To
export const loadUnAssignedTo = createAction(
  '[Leave Policy] Load UnAssigned To',
  props<{ leavePolicyId: string; params: string | null; page?: number; limit?: number }>()
)
export const loadUnAssignedToSuccess = createAction(
  '[Leave Policy] Load UnAssigned To Success',
  props<{ unassignedTo: User[]; totalUserCount: number }>()
)
export const loadUnAssignedToFailure = createAction(
  '[Leave Policy] Load Assigned To Failure',
  props<{ error: string }>()
)

//Delete Assigned To
export const deleteAssignedTo = createAction(
  '[Leave Policy] Delete Assigned To',
  props<{ id: string }>()
)
export const deleteAssignedToSuccess = createAction(
  '[Role] Delete Assigned To Success',
  props<{ assignedTo: AssignedTo[] }>()
)
export const deleteAssignedToFailure = createAction(
  '[Role] Delete Assigned To Failure',
  props<{ error: string }>()
)

export const resetAssignedToState = createAction('[AssignedTo] Reset State')
